import React from 'react';
import Card from 'react-bootstrap/Card';
import Spinner from 'react-bootstrap/Spinner';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';
import { ChargeAttemptDataPoint } from '../../types/payment.types';

interface ChargeAttemptsChartProps {
  dataPoints: ChargeAttemptDataPoint[] | undefined;
  isLoading: boolean;
}

function ChargeAttemptsChart({ dataPoints, isLoading }: ChargeAttemptsChartProps) {
  const chartData =
    dataPoints?.map((point) => ({
      date: new Date(point.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
      Successful: point.successCount,
      Failed: point.failCount
    })) ?? [];

  return (
    <Card className="h-100">
      <Card.Header>Charge Attempts</Card.Header>
      <Card.Body>
        {isLoading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: 250 }}>
            <Spinner animation="border" />
          </div>
        ) : (
          <ResponsiveContainer width="100%" height={250}>
            <LineChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" tick={{ fontSize: 12 }} />
              <YAxis tick={{ fontSize: 12 }} />
              <Tooltip />
              <Legend />
              <Line
                type="monotone"
                dataKey="Successful"
                stroke="#198754"
                strokeWidth={2}
                dot={{ r: 3 }}
                activeDot={{ r: 5 }}
              />
              <Line
                type="monotone"
                dataKey="Failed"
                stroke="#dc3545"
                strokeWidth={2}
                dot={{ r: 3 }}
                activeDot={{ r: 5 }}
              />
            </LineChart>
          </ResponsiveContainer>
        )}
      </Card.Body>
    </Card>
  );
}

export default ChargeAttemptsChart;
